import { User } from "firebase/auth";


export interface MLFirebaseUser {
    accessToken: string;
    displayName: string | null;
    email: string | null;
    photoUrl: string | null;
    deviceId: string;
    location: string | null;
    country: string | null;
    //providerId:string;
    // providerUID:string;
}


export async function createMLUserFromFB(user: User, deviceId: string, country?: string): Promise<MLFirebaseUser> {

    let receivedToken = await user?.getIdToken(true);

    let countryVal = country !== undefined ? country : "00";

    return {
        accessToken: receivedToken,
        displayName: user.displayName,
        email: user.email,
        photoUrl: user.photoURL,
        deviceId: deviceId,
        location: null, //TODO.
        country: countryVal
    };
}